import { HasChildrenId, isHasChildrenId } from './hasChildren';
import { isMarriageStatusId, MarriageStatusId } from './marriageStatus';

type InvalidParam = {
  name: 'marriageStatus' | 'hasChildren';
  reason: string;
};

type FamilyStructureValidatorResponse = {
  isValidate: boolean;
  invalidParams?: InvalidParam[];
};

type FamilyStructureValidatorRequest = {
  marriageStatus?: MarriageStatusId;
  hasChildren?: HasChildrenId;
};

export const familyStructureValidator = ({
  marriageStatus,
  hasChildren,
}: FamilyStructureValidatorRequest): FamilyStructureValidatorResponse => {
  const result = { isValidate: true };

  const invalidParams = [] as InvalidParam[];

  if (!marriageStatus) {
    result.isValidate = false;
    invalidParams.push({
      name: 'marriageStatus',
      reason: '結婚状況と子供の有無は一緒に設定して下さい。',
    });
  }

  // eslint-disable-next-line no-eq-null
  if (hasChildren == null) {
    result.isValidate = false;
    invalidParams.push({
      name: 'hasChildren',
      reason: '結婚状況と子供の有無は一緒に設定して下さい。',
    });
  }

  if (isMarriageStatusId(marriageStatus) === false) {
    result.isValidate = false;
    invalidParams.push({
      name: 'marriageStatus',
      reason: '結婚状況の値が不正です。',
    });
  }

  if (!isHasChildrenId(hasChildren)) {
    result.isValidate = false;
    invalidParams.push({
      name: 'hasChildren',
      reason: '子供の有無の値が不正です。',
    });
  }

  if (!result.isValidate) {
    return {
      isValidate: false,
      invalidParams,
    };
  }

  return result;
};
